<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>

    <div v-show="!loading" class="content">
        <div class="box box-primary box-solid">
            <div class="box-body">

                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                    </div>
                </div>

                <ul class="nav nav-tabs">
                    <li class="active"><a data-toggle="tab" href="#details">Details</a></li>
                    <li><a data-toggle="tab" href="#permissions">Permissions</a></li>
                </ul>

                <div class="tab-content content">
                    <div id="details" class="tab-pane fade in active">

                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">

                            <div class="col-sm-4 col-sm-offset-4">

                              <validate auto-label class="form-group" :class="fieldClassName(formstate.rank)">
                                    <vue-form-input required v-model="role.rank" :formstate="formstate" :type="'text'" :label="'Rank:'" :name="'rank'" :messages="{ required: 'This field is required' }">
                                    </vue-form-input>
                                </validate>

                                <validate auto-label class="form-group" :class="fieldClassName(formstate.name)">
                                    <vue-form-input required v-model="role.name" :formstate="formstate" :type="'text'" :label="'Name:'" :name="'name'" :messages="{ required: 'This field is required' }">
                                    </vue-form-input>
                                </validate>

                                <validate auto-label class="form-group" :class="fieldClassName(formstate.description)">
                                    <vue-form-input v-model="role.description" :formstate="formstate" :type="'text'" :label="'Description:'" :name="'description'">
                                    </vue-form-input>
                                </validate>

                            </div>

                        </vue-form>

                        <div class="py-2 text-center row" style="margin-top: 10px">
                            <button class="btn btn-primary" type="submit" @click="createRole" :disabled="!(formstate.$valid)" v-if="$route.params && !$route.params._id">Create Role</button>
                        </div>
                        <div class="py-2 text-center row" style="margin-top: 10px">
                            <!-- :disabled="formstate.$pristine || formstate.$invalid" v-permission.enable="['role', 'updateRole']" -->
                            <button class="btn btn-primary" type="submit" @click="updateRole"  v-if="$route.params && $route.params._id">Update Role</button>
                        </div>

                    </div>
                    <div id="permissions" class="tab-pane fade">
                        <role-permissions :role="role" v-if="!loading"></role-permissions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import RolePermissions from './RolePermissions.vue'
import {
    roleService,
    formService,
    eventBus
} from '../../../services'
import {
    EVENTS
} from '../../../config'

export default {
    name: 'RoleCreate',
    components: {
        RolePermissions
    },
    data() {
        return {
            ready: false,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            role: {},
            roles: [],
            permissions: [],
            formstate: {},
            newRole: {},
            oldRole: {},
        }
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        getRole() {
            console.log('inside getRole')
            const params = {
                $embed: ['permissions']
            }

            return this.$roleRepository.find(this.$route.params._id, params)
                .then((response) => {
                    this.role = response.data
                    this.oldRole = _.cloneDeep(this.role)
                    this.$store.dispatch('setBreadcrumbTitle', this.role.name)
                })
                .catch((error) => {
                    console.error('RoleDetails.getRole-error:', error)
                    this.$snotify.error('Get role failed', 'Error!')
                })
        },
        clearChanges() {
            this.role = _.cloneDeep(this.oldRole)
            this.formstate._reset()
        },
        updateRole() {
            this.loading = true
            return roleService.updateRole(this.role, this.oldRole)
                .then((response) => {
                    this.loading = false
                    this.flash = false
                    this.formstate._reset()
                    this.oldRole = _.cloneDeep(this.role)
                    this.$snotify.success('Role updated', 'Success!')
                    this.$router.push('/roles')
                })
                .catch(error => {
                    this.loading = false
                    console.error('RoleDetails.updateRole-error:', error)
                    this.$snotify.error('Update role failed', 'Error!')
                    if (error.data.message.includes('must be one of')) {
                        this.flash = true
                        this.flashType = 'error'
                        this.flashMessage = 'That role name is not allowed. You must first update the list of allowed role names' +
                            ' in the appy client and server config.'
                    }
                })
        },
        updatePermissions(newPermissions) {
            this.role.permissions = newPermissions
            this.formstate.roleUpdated._setDirty()
        },




        createRole() {
            this.loading = true
            return roleService.createRole(this.role)
                .then((response) => {
                    this.loading = false
                    this.flash = false
                    this.$snotify.success('Role created', 'Success!')
                    this.$router.push('/roles')
                })
                .catch(error => {
                    this.loading = false
                    console.error('RoleCreate.createRole-error:', error)
                    this.$snotify.error('Create role failed', 'Error!')
                    if (error.data.message.includes('must be one of')) {
                        this.flash = true
                        this.flashType = 'error'
                        this.flashMessage = 'That role name is not allowed. You must first update the list of allowed role names' +
                            ' in the thinkGas server config.'
                    }
                })
        }
    },
    // created() {
    //     const promises = []
    //     this.loading = true
    //     promises.push(this.getRole())
    //     Promise.all(promises)
    //         .then(() => {
    //             this.loading = false
    //             this.ready = true
    //         })
    //         .catch(() => {
    //             this.loading = false
    //         })
    //     eventBus.$on(EVENTS.PERMISSIONS_UPDATED, this.updatePermissions)
    // },
    created() {
                const promises = [];
                this.loading = true;
                console.log('inside created getroles')
    
                // promises.push(this.getRole());
                if (this.$route.params && this.$route.params._id) {
                    promises.push(this.getRole());
                }
                Promise.all(promises)
                    .then(() => {
                        this.loading = false;
                        this.ready = true;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            // beforeDestroy() {},
    beforeDestroy() {
        eventBus.$off(EVENTS.PERMISSIONS_UPDATED, this.updatePermissions)
    },
    // created() {
    //     eventBus.$on(EVENTS.PERMISSIONS_UPDATED, (newPermissions) => {
    //         this.role.permissions = newPermissions
    //     })
    // }
}
</script>



// WEBPACK FOOTER //
// RoleCreate.vue?ba220640